import { Link } from 'react-router-dom';
import { heroMedia } from '../utils/mediaConfig.js';

const DataCenters = () => (
  <>
  <section className="relative h-[860px] tablet:px-6 tablet:h-auto tablet:min-h-[560px]">
    <video autoPlay muted loop playsInline preload="metadata" poster={heroMedia.dataCenters.poster} aria-hidden="true" className="absolute inset-0 w-full h-full object-cover">
      <source src={heroMedia.dataCenters.video} type="video/mp4" />
    </video>
    <div className="absolute inset-0 [background:linear-gradient(90deg,_rgba(7,9,53,0.97)_0%,_rgba(7,9,53,0.8)_50%,_rgba(7,9,53,0.2)_100%)]">
    </div>
    <div className="relative pt-[240px] px-[120px] pb-0 max-w-[940px] flex flex-col gap-7 tablet:pt-[124px] tablet:px-6 tablet:pb-16">
      <p className="m-0 text-[16px] text-mx-accent-light tracking-[0.04em] font-display">
        Data centers
      </p>
      <h1 className="m-0 font-medium text-[76px] leading-[1.04] tracking-[-0.02em] font-display tablet:text-[44px] tablet:leading-[1.08]">
        Components for every phase of the data center build
      </h1>
      <p className="m-0 text-[20px] leading-[1.6] text-mx-copy max-w-[700px]">
        From the duct bank to the white space: supports, enclosures, fabricated steel, machined and molded parts, built to your drawings and delivered on your schedule. A second source when distributor lead times put the job at risk.
      </p>
      <div className="flex gap-4 mt-2 phone:flex-wrap">
        <Link to="/contact" className="mx-button">
          Send us your BOM or drawing
        </Link>
        <Link to="#dc-products" className="mx-button-outline">
          What we supply
        </Link>
      </div>
    </div>
  </section>
  <section id="dc-products" className="pt-[140px] px-[120px] pb-0 flex flex-col gap-12 tablet:px-6">
    <div className="flex justify-between items-end gap-12 tablet:flex-wrap">
      <h2 className="m-0 font-medium text-[52px] leading-[1.1] max-w-[640px] font-display tablet:text-[32px]">
        From the ground up
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] text-mx-muted max-w-[460px]">
        Standard parts in volume and custom parts to print, for each stage of the build.
      </p>
    </div>
    <div className="grid [grid-template-columns:repeat(3,_minmax(0,_1fr))] gap-0 border-t border-mx-border border-l border-mx-border tablet:[grid-template-columns:1fr]">
      <div className="p-9 border-r border-mx-border border-b border-mx-border flex flex-col gap-3 tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          Site and underground
        </span>
        <h3 className="m-0 font-semibold text-[22px] font-display">
          Duct bank materials
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          HDPE and PVC conduit, spacers, couplings, end bells and pre-kitted duct bank runs.
        </p>
        <Link to="/data-center-conduit" className="mt-1 font-semibold text-[15px] text-mx-accent-light font-display">
          See the conduit range
        </Link>
      </div>
      <div className="p-9 border-r border-mx-border border-b border-mx-border flex flex-col gap-3 tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          Structure
        </span>
        <h3 className="m-0 font-semibold text-[22px] font-display">
          Supports and hangers
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Strut channel, brackets, trapeze hangers, threaded rod and seismic bracing hardware.
        </p>
      </div>
      <div className="p-9 border-r border-mx-border border-b border-mx-border flex flex-col gap-3 tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          Power distribution
        </span>
        <h3 className="m-0 font-semibold text-[22px] font-display">
          Enclosures and fabricated steel
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Pull boxes, junction boxes, custom enclosures, busbar and grounding components.
        </p>
      </div>
      <div className="p-9 border-r border-mx-border border-b border-mx-border flex flex-col gap-3 tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          White space
        </span>
        <h3 className="m-0 font-semibold text-[22px] font-display">
          Cable management and containment
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Cable tray, ladder rack, containment panels, blanking panels and rack mounting parts.
        </p>
      </div>
      <div className="p-9 border-r border-mx-border border-b border-mx-border flex flex-col gap-3 tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          Mechanical and cooling
        </span>
        <h3 className="m-0 font-semibold text-[22px] font-display">
          Piping supports and fittings
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Pipe supports, flanges, manifolds and machined fittings for cooling systems.
        </p>
      </div>
      <div className="p-9 border-r border-mx-border border-b border-mx-border flex flex-col gap-3 bg-mx-card tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          Anything on your drawing
        </span>
        <h3 className="m-0 font-semibold text-[22px] font-display">
          Custom parts to print
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-copy">
          Machined, molded, stamped or welded. If you can draw it, we can source and deliver it.
        </p>
      </div>
    </div>
  </section>
  <section id="dc-conduit" className="pt-[120px] px-[120px] pb-0 tablet:px-6">
    <Link to="/data-center-conduit" className="grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] bg-mx-card border border-mx-border rounded-3xl overflow-hidden tablet:[grid-template-columns:1fr]">
      <img src="/media/images/duct-bank-trench.jpg" alt="Conduit duct bank in an open trench at a data center site" loading="lazy" className="h-[380px] border-0 block w-full object-cover tablet:min-w-0" />
      <div className="p-14 flex flex-col justify-center gap-4 tablet:min-w-0">
        <span className="text-[14px] text-mx-accent-light">
          Conduit and duct bank systems
        </span>
        <h2 className="m-0 font-semibold text-[36px] leading-[1.15] font-display tablet:text-[32px]">
          HDPE and PVC conduit, accessories and assembled duct bank
        </h2>
        <p className="m-0 text-[17px] leading-[1.6] text-mx-copy">
          Conduit, spacers, couplers, end bells, plugs and pull tape from one manufacturer, built to your print and certified to ASTM, NEMA and UL standards.
        </p>
        <span className="mt-2 font-semibold text-mx-accent-light font-display">
          See the conduit range
        </span>
      </div>
    </Link>
  </section>
  <section className="pt-40 px-[120px] pb-0 flex flex-col gap-12 tablet:px-6">
    <div className="flex justify-between items-end gap-12 tablet:flex-wrap">
      <div className="flex flex-col gap-4 max-w-[700px]">
        <p className="m-0 text-[16px] text-mx-accent-light tracking-[0.04em] font-display">
          How we work with you
        </p>
        <h2 className="m-0 font-medium text-[52px] leading-[1.1] font-display tablet:text-[32px]">
          Built around how your team buys
        </h2>
      </div>
      <p className="m-0 text-[18px] leading-[1.6] text-mx-muted max-w-[460px]">
        You carry the schedule and the margin on every package. We set up supply so your estimators, purchasing and field teams all get what they need.
      </p>
    </div>
    <div className="grid [grid-template-columns:repeat(4,_minmax(0,_1fr))] gap-6 tablet:[grid-template-columns:1fr]">
      <div className="p-8 bg-mx-card border border-mx-border rounded-[20px] flex flex-col gap-3.5 tablet:min-w-0">
        <span className="text-[13px] text-mx-accent-light font-mono">
          Estimating
        </span>
        <h3 className="m-0 font-semibold text-[22px] leading-[1.25] font-display">
          Pricing you can bid with
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Line-by-line, duty-paid quotes in 2 business days, so your number holds from bid to buyout.
        </p>
      </div>
      <div className="p-8 bg-mx-card border border-mx-border rounded-[20px] flex flex-col gap-3.5 tablet:min-w-0">
        <span className="text-[13px] text-mx-accent-light font-mono">
          Purchasing
        </span>
        <h3 className="m-0 font-semibold text-[22px] leading-[1.25] font-display">
          One contact, quotes against your BOM
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          A single point of contact who knows your job, with quotes laid out to match your bill of materials.
        </p>
      </div>
      <div className="p-8 bg-mx-card border border-mx-border rounded-[20px] flex flex-col gap-3.5 tablet:min-w-0">
        <span className="text-[13px] text-mx-accent-light font-mono">
          Inventory and tracking
        </span>
        <h3 className="m-0 font-semibold text-[22px] leading-[1.25] font-display">
          Status by PO line
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Shipment updates against your PO numbers and packing lists that match your line items.
        </p>
      </div>
      <div className="p-8 bg-mx-card border border-mx-border rounded-[20px] flex flex-col gap-3.5 tablet:min-w-0">
        <span className="text-[13px] text-mx-accent-light font-mono">
          Scope
        </span>
        <h3 className="m-0 font-semibold text-[22px] leading-[1.25] font-display">
          Every process, one supplier
        </h3>
        <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
          Machined, molded, stamped, fabricated and assembled parts in aluminum, copper, brass, stainless and engineering plastics.
        </p>
      </div>
    </div>
  </section>
  <section className="relative mt-40 mx-12 mb-0 h-[620px] rounded-[28px] overflow-hidden border border-mx-border tablet:px-6 tablet:mx-4 tablet:h-auto tablet:min-h-[560px]">
    <video autoPlay muted loop playsInline preload="metadata" poster={heroMedia.ductBank.poster} aria-hidden="true" className="absolute inset-0 w-full h-full object-cover">
      <source src={heroMedia.ductBank.video} type="video/mp4" />
    </video>
    <div className="absolute inset-0 [background:linear-gradient(90deg,_rgba(7,9,53,0.95)_0%,_rgba(7,9,53,0.7)_55%,_rgba(7,9,53,0.15)_100%)]">
    </div>
    <div className="relative h-full box-border px-[72px] py-0 flex flex-col justify-center gap-9 max-w-[760px]">
      <h2 className="m-0 font-medium text-[48px] leading-[1.1] font-display tablet:text-[32px]">
        Delivered on your build sequence, hall by hall
      </h2>
      <ul className="m-0 p-0 list-none flex flex-col gap-4 text-[18px] leading-[1.5] text-mx-nav-text">
        <li className="flex gap-3.5">
          <span className="w-2 h-2 mt-[9px] rounded-sm bg-mx-accent shrink-0">
          </span>
          Release schedules matched to your pour and pull dates
        </li>
        <li className="flex gap-3.5">
          <span className="w-2 h-2 mt-[9px] rounded-sm bg-mx-accent shrink-0">
          </span>
          Pallets labeled by building, hall and work area
        </li>
        <li className="flex gap-3.5">
          <span className="w-2 h-2 mt-[9px] rounded-sm bg-mx-accent shrink-0">
          </span>
          Duty-paid delivery straight to the jobsite laydown yard
        </li>
      </ul>
    </div>
  </section>
  <section className="pt-40 px-[120px] pb-0 grid [grid-template-columns:repeat(3,_minmax(0,_1fr))] gap-8 tablet:px-6 tablet:[grid-template-columns:1fr]">
    <div className="flex flex-col gap-3 pt-6 border-t-2 border-mx-accent tablet:min-w-0">
      <h3 className="m-0 font-semibold text-[22px] font-display">
        Electrical and mechanical contractors
      </h3>
      <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
        Firm pricing and sequenced deliveries that protect your margin on long builds.
      </p>
    </div>
    <div className="flex flex-col gap-3 pt-6 border-t-2 border-mx-accent tablet:min-w-0">
      <h3 className="m-0 font-semibold text-[22px] font-display">
        General contractors
      </h3>
      <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
        Another qualified source when distributor lead times put the schedule at risk.
      </p>
    </div>
    <div className="flex flex-col gap-3 pt-6 border-t-2 border-mx-accent tablet:min-w-0">
      <h3 className="m-0 font-semibold text-[22px] font-display">
        Owners and developers
      </h3>
      <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
        Campus-wide standard parts, supplied the same way across every phase.
      </p>
    </div>
  </section>
  <section className="mt-[140px] mx-[120px] mb-0 py-[72px] px-20 bg-mx-accent rounded-[28px] flex justify-between items-center gap-12 tablet:px-6 tablet:mx-4 tablet:flex-wrap">
    <div className="flex flex-col gap-3 text-mx-ink">
      <h2 className="m-0 font-semibold text-[44px] leading-[1.1] font-display tablet:text-[32px]">
        Pricing a data center package?
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] max-w-[620px]">
        Send your drawings or bill of materials and the phase schedule. We quote it line by line, duty-paid, within 2 business days.
      </p>
    </div>
    <Link to="/contact" className="inline-flex items-center min-h-14 px-8 py-0 rounded-[999px] bg-mx-ink text-white font-semibold text-[16px] whitespace-nowrap font-display">
      Request a quote
    </Link>
  </section>
  </>
);
export default DataCenters;
